import { render, staticRenderFns } from "./TeacherSpecializeForm.vue?vue&type=template&id=647f19b3"
import script from "./TeacherSpecializeForm.vue?vue&type=script&lang=js"
export * from "./TeacherSpecializeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports